<template>
  <div class="d-flex flex-wrap justify-content-around">
    <draggable
      :options="{group: {name: 'widgets', pull: 'clone', put:false}, sort: false}"
      class="d-flex flex-wrap justify-content-around"
    >
      <!-- Tools here -->
      <tool
        icon="images"
        label="Images"
        type="image"
      />
      <tool
        icon="shop"
        label="Products"
        type="product"
      />
      <tool
        icon="text"
        label="Text"
        type="text"
      />
    </draggable>
  </div>
</template>
<script>
import draggable from 'vuedraggable';

export default {
  name: 'Tools',
  components: {
    draggable,
  },
  methods: {},
};
</script>
